import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft20 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.52467 9.16667L9.50801 6.175L8.33301 5L3.33301 10L8.33301 15L9.50801 13.825L6.52467 10.8333H16.6663V9.16667H6.52467Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowLeft20);
export default ForwardRef;
